import { itx } from "../../src/translationItx/itx";

// UI labels are resolved on access so loading or switching the app language updates them.
// Catalog texts retain their own language data; UI and saved-name aliases use app locales.

export const C1_ELO_ITEM_TYPE_LABELS: Record<string, string> = {
  get group() {
    return itx("components.group", "Gruppe");
  },
  get plug_group() {
    return itx("components.plural.Outlet", "Steckdosen");
  },
  get blind() {
    return itx("components.Blind", "Rollladen");
  },
  get jalousie() {
    return itx("components.Jalousie", "Jalousie");
  },
  get light() {
    return itx("components.light", "Leuchte");
  },
  get plug() {
    return itx("components.Outlet", "Steckdose");
  },
  get button() {
    return itx("components.Button", "Taster");
  },
  get panel() {
    return itx("c1.ui.Bedienpanel", "Bedienpanel");
  },
  get fixed_power() {
    return itx("c1.ui.Festanschluss", "Festanschluss");
  },
  get door_station() {
    return itx("c1.ui.Turkommunikation", "Türkommunikation");
  },
  get window_contact() {
    return itx("components.Lock", "Kontakt");
  },
  get motion_sensor() {
    return itx("components.SensorNew", "Sensor");
  },
  get door_lock() {
    return itx("c1.ui.Turschloss", "Türschloss");
  },
  get thermostat() {
    return itx("c1.ui.Thermostat", "Thermostat");
  },
  get heating() {
    return itx("components.Heating", "Heizung");
  },
  get camera() {
    return itx("c1.ui.Kamera", "Kamera");
  },
};

export const ROOM_TYPE_LABELS: Record<string, string> = {
  get living() {
    return itx("defaultCabinetAndScenes.living", "Wohnen");
  },
  get dining() {
    return itx("step2.diningRoom", "Esszimmer");
  },
  get kitchen() {
    return itx("step2.kitchen", "Küche");
  },
  get hallway() {
    return itx("step2.corridor", "Flur");
  },
  get staircase() {
    return itx("c1.labels.room_type.staircase", "Treppe");
  },
  get "guest-toilet"() {
    return itx("c1.labels.room_type.guest-toilet", "Gäste-WC");
  },
  get utility() {
    return itx("c1.labels.room_type.utility", "Hauswirtschaftsraum");
  },
  get office() {
    return itx("c1.labels.room_type.office", "Arbeitszimmer");
  },
  get child() {
    return itx("c1.labels.room_type.child", "Kind");
  },
  get bathroom() {
    return itx("c1.labels.room_type.bathroom", "Badezimmer");
  },
  get bedroom() {
    return itx("step2.bedroom", "Schlafzimmer");
  },
  get storage() {
    return itx("step2.storageRoom", "Abstellraum");
  },
  get hobby() {
    return itx("c1.labels.room_type.hobby", "Hobbyraum");
  },
  get laundry() {
    return itx("c1.labels.room_type.laundry", "Waschküche");
  },
  get "heating-room"() {
    return itx("c1.labels.room_type.heating-room", "Heizungsraum");
  },
  get "utility-connection-room"() {
    return itx("c1.labels.room_type.utility-connection-room", "Hausanschlussraum");
  },
  get garage() {
    return itx("step1.garage", "Garage");
  },
  get "detached-garage"() {
    return itx("c1.labels.room_type.detached-garage", "Garage freistehend");
  },
  get terrace() {
    return itx("step1.patio", "Terrasse");
  },
  get carport() {
    return itx("c1.labels.room_type.carport", "Carport");
  },
  get other() {
    return itx("c1.labels.room_type.other", "Sonstiger Raum");
  },
  get balcony() {
    return itx("c1.labels.room_type.balcony", "Balkon");
  },
  get garden() {
    return itx("step1.garden", "Garten");
  },
  get entrance() {
    return itx("c1.labels.room_type.entrance", "Eingang");
  },
  get "garage-driveway"() {
    return itx("c1.labels.room_type.garage-driveway", "Garagen-Einfahrt");
  },
  get "roof-terrace"() {
    return itx("c1.labels.room_type.roof-terrace", "Dachterrasse");
  },
  get "penthouse-perimeter"() {
    return itx("c1.labels.room_type.penthouse-perimeter", "Staffelgeschoss-Außen");
  },
  get roof() {
    return itx("c1.labels.room_type.roof", "Dach");
  },
};

export const FURNITURE_CATEGORY_LABELS: Record<string, string> = {
  get living() {
    return itx("defaultCabinetAndScenes.living", "Wohnen");
  },
  get dining() {
    return itx("step2.diningRoom", "Esszimmer");
  },
  get kitchen() {
    return itx("step2.kitchen", "Küche");
  },
  get hallway() {
    return itx("step2.corridor", "Flur");
  },
  get staircase() {
    return itx("c1.labels.furniture_category.staircase", "Treppe");
  },
  get "guest-toilet"() {
    return itx("c1.labels.furniture_category.guest-toilet", "Gäste-WC");
  },
  get utility() {
    return itx("c1.labels.furniture_category.utility", "Hauswirtschaftsraum");
  },
  get office() {
    return itx("c1.labels.furniture_category.office", "Arbeitszimmer");
  },
  get bathroom() {
    return itx("c1.labels.furniture_category.bathroom", "Badezimmer");
  },
  get bedroom() {
    return itx("step2.bedroom", "Schlafzimmer");
  },
  get storage() {
    return itx("step2.storageRoom", "Abstellraum");
  },
  get hobby() {
    return itx("c1.labels.furniture_category.hobby", "Hobbyraum");
  },
  get laundry() {
    return itx("c1.labels.furniture_category.laundry", "Waschküche");
  },
  get "heating-room"() {
    return itx("c1.labels.furniture_category.heating-room", "Heizungsraum");
  },
  get "utility-connection-room"() {
    return itx("c1.labels.furniture_category.utility-connection-room", "Hausanschlussraum");
  },
  get garage() {
    return itx("step1.garage", "Garage");
  },
  get "detached-garage"() {
    return itx("c1.labels.furniture_category.detached-garage", "Garage freistehend");
  },
  get terrace() {
    return itx("step1.patio", "Terrasse");
  },
  get balcony() {
    return itx("c1.labels.furniture_category.balcony", "Balkon");
  },
  get garden() {
    return itx("step1.garden", "Garten");
  },
  get entrance() {
    return itx("c1.labels.furniture_category.entrance", "Eingang");
  },
  get "garage-driveway"() {
    return itx("c1.labels.furniture_category.garage-driveway", "Garagen-Einfahrt");
  },
  get "roof-terrace"() {
    return itx("c1.labels.furniture_category.roof-terrace", "Dachterrasse");
  },
  get "penthouse-perimeter"() {
    return itx("c1.labels.furniture_category.penthouse-perimeter", "Staffelgeschoss-Außen");
  },
  get roof() {
    return itx("c1.labels.furniture_category.roof", "Dach");
  },
  get all() {
    return itx("menuBar.all", "Alle");
  },
  get none() {
    return itx("menuBar.none", "Keine");
  },
  get decoration() {
    return itx("c1.labels.furniture_category.decoration", "Dekoration");
  },
  get electrical() {
    return itx("c1.ui.Elektro", "Elektro");
  },
  get "electrical-equipment"() {
    return itx("c1.labels.furniture_category.electrical-equipment", "Geräte");
  },
  get outdoor() {
    return itx("c1.labels.furniture_category.outdoor", "Außen");
  },
};

export const C1_ELO_LIGHT_TYPE_LABELS: Record<string, string> = {
  get Switch() {
    return itx("channelType.Switch", "Schalten");
  },
  get StaircaseLight() {
    return itx("components.StaircaseLight", "Treppenhauslicht");
  },
  get Dimmer() {
    return itx("channelType.Dimmer", "Dimmen");
  },
  get Rgb() {
    return itx("channelType.Rgb", "RGB");
  },
  get TuneableWhite() {
    return itx("c1.labels.elo_light_type.TuneableWhite", "Tunable White");
  },
};

export const C1_ELO_PLUG_TYPE_LABELS: Record<string, string> = {
  get plug_Switch() {
    return itx("c1.labels.elo_plug_type.230V_switch", "230 V geschaltet");
  },
  get plug_Switch1() {
    return itx("c1.labels.elo_plug_type.230V_switch_1", "230 V geschaltet (Kreis 1)");
  },
  get plug_Switch2() {
    return itx("c1.labels.elo_plug_type.230V_switch_2", "230 V geschaltet (Kreis 2)");
  },
  get plug_Switch3() {
    return itx("c1.labels.elo_plug_type.230V_switch_3", "230 V geschaltet (Kreis 3)");
  },
  get plug_230V() {
    return itx("c1.labels.elo_plug_type.230V", "230 V");
  },
  get plug_LAN() {
    return itx("channelType.Lan", "LAN");
  },
  get plug_LAN2() {
    return itx("c1.labels.elo_plug_type.LAN 2", "LAN 2");
  },
  get plug_USB() {
    return itx("c1.labels.elo_plug_type.USB", "USB");
  },
  get plug_TV() {
    return itx("c1.ui.TV", "TV");
  },
};

/** Recognize persisted generated names after language changes without keeping a parallel translation table. */
export function generatedPlugTypeNames(plugType: string): string[] {
  const aliasKey = ({
    plug_230V: "230V", plug_Switch: "230V_switch", plug_Switch1: "230V_switch_1",
    plug_Switch2: "230V_switch_2", plug_Switch3: "230V_switch_3", plug_LAN: "LAN",
    plug_LAN2: "LAN 2", plug_USB: "USB", plug_TV: "TV",
  } as Record<string, string>)[plugType] ?? plugType;
  return [C1_ELO_PLUG_TYPE_LABELS[plugType],
    itx(`c1.generatedNameAliases.elo_plug_type.${aliasKey}.de`),
    itx(`c1.generatedNameAliases.elo_plug_type.${aliasKey}.en`),
  ].filter(Boolean).map(name => name.trim());
}

/** Recognizes automatic slot labels even after the socket's channel type changed. */
export function isGeneratedPlugItemName(name: string, repeatIndex: number): boolean {
  return Object.keys(C1_ELO_PLUG_TYPE_LABELS).some(type =>
    generatedPlugTypeNames(type).some(label => name.trim() === `#${repeatIndex} - ${label}`));
}

export const C1_ELO_VOLTAGE_LABELS: Record<string, string> = {
  get "230V"() {
    return itx("c1.labels.elo_voltage.230V", "230 V");
  },
  get "400V"() {
    return itx("c1.labels.elo_voltage.400V", "400 V");
  },
};

export const C1_ELO_SENSOR_TYPE_LABELS: Record<string, string> = {
  get motion() {
    return itx("c1.labels.elo_sensor_type.motion", "Bewegung");
  },
  get temperature() {
    return itx("c1.labels.elo_sensor_type.temperature", "Temperatur");
  },
  get humidity() {
    return itx("c1.labels.elo_sensor_type.humidity", "Luftfeuchtigkeit");
  },
  get co2() {
    return itx("c1.labels.elo_sensor_type.co2", "CO₂");
  },
  get smoke() {
    return itx("c1.labels.elo_sensor_type.smoke", "Rauch");
  },
  get water_leak_detector() {
    return itx("c1.labels.elo_sensor_type.water_leak_detector", "Wassermelder");
  },
  get window_contact() {
    return itx("components.Lock", "Kontakt");
  },
};

export const C1_WINDOW_SHADING_LABELS: Record<string, string> = {
  get none() {
    return itx("menuBar.none", "Keine");
  },
  get blind() {
    return itx("toolBar.blindShort", "Rollo");
  },
  get jalousie() {
    return itx("components.Jalousie", "Jalousie");
  },
};

export const C1_DOOR_TYPE_UI_LABELS: Record<string, string> = {
  get passage() {
    return itx("c1.ui.Durchgang", "Durchgang");
  },
  get interior() {
    return itx("c1.ui.Innentur", "Innentür");
  },
  get entrance() {
    return itx("c1.ui.Haustur", "Haustür");
  },
  get garden() {
    return itx("c1.ui.Gartentur", "Gartentür");
  },
};

export const C1_GARAGE_DOOR_TYPE_UI_LABELS: Record<string, string> = {
  get roller() {
    return itx("c1.labels.garage_door_type.roller", "Rolltor");
  },
  get sectional() {
    return itx("c1.labels.garage_door_type.sectional", "Sektionaltor");
  },
  get "up-and-over"() {
    return itx("c1.labels.garage_door_type.up-and-over", "Schwingtor");
  },
};
